// extracted by mini-css-extract-plugin
export var callCard = "_ph-0";
export var callMessageButton = "_ph-1";
export var helpIcon = "_ph-3";
export var helpIconContainer = "_ph-4";
export var verticalDivider = "_ph-2";